import { createContext } from 'react';
export const MerchantContext = createContext({
  featureToggles: {},
  instantRefundsFreeTrialEligibility: {},
  easySplitEnabled: false,
  routerStatus: '',
  isFlowwiseActive: false,
  shopifyStoreUrl: null,
  showRouterTab: false,
  showBatchLinkUpload: false,
  isShopifyMerchant: false,
  renderChatbot: false,
  productStatus: {},
  productPrivilege: {},
  productFruitCampaigns: {},
  isMerchantImportEnabled: false,
  isTransactionCurrencyEnabled: false,
  // eslint-disable-next-line no-unused-vars
  setMerchantContextData: data => {},
  resetFeatureToggles: () => {},
  selectedTimeZone: 'IST',
  setSelectedTimeZone: () => {},
});
